var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject, Subject } from 'rxjs';
import { INDRAStorageService } from './storage.indra.service';
import { INDRABookingStep } from '@ibe.components/booking/steps/booking-steps/bookingStep.indra';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "./storage.indra.service";
var INDRABFMDataStorageService = /** @class */ (function () {
    function INDRABFMDataStorageService(storageService) {
        this.storageService = storageService;
        this._selectedFlightChange = undefined;
        this._flightToBeChange = undefined;
        this._selectedFlightUpgradeCash = undefined;
        this._selectedBrandUpgradeCash = undefined;
        this._selectedBrandToChange = undefined;
        this._paxToBeChange = undefined;
        this.selectedBrandSubject = new Subject();
        this._observableCurrentBooking = new BehaviorSubject(this.activeBooking);
        this._availabilityDatelist$ = new BehaviorSubject(null);
        this.timeToThinkCode = new BehaviorSubject(this._timeToThinkCode);
    }
    /**
     * Retrieves a booked trip from the data store.
     */
    INDRABFMDataStorageService.prototype.INDRA_getActiveBookedTrip = function () {
        if (this._activeBooking == undefined)
            this._activeBooking = this.storageService.get("INDRABFMDataStorageService._activeBooking");
        return this._activeBooking;
    };
    /**
     * Stores the booked trip data.
     * @param {string} booking - the booked trip to be stored
     */
    INDRABFMDataStorageService.prototype.INDRA_setActiveBookedTrip = function (booking) {
        this._activeBooking = booking;
        this.storageService.set("INDRABFMDataStorageService._activeBooking", this._activeBooking);
        this._observableCurrentBooking.next(this._activeBooking);
    };
    INDRABFMDataStorageService.prototype.INDRA_getObservableCurrentBooking = function () {
        return this._observableCurrentBooking.asObservable();
    };
    INDRABFMDataStorageService.prototype.INDRA_getActiveBookInfoPax = function () {
        return this.INDRA_getActiveBookedTrip() && this.INDRA_getActiveBookedTrip().data ? this.INDRA_getActiveBookedTrip().data.infoPax : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_setActiveBookInfoPax = function (infoPax) {
        this._activeBooking = this.INDRA_getActiveBookedTrip();
        var activeBooking = __assign({}, this._activeBooking, { data: __assign({}, this._activeBooking.data, { infoPax: infoPax }) });
        this.storageService.set("INDRABFMDataStorageService._activeBooking", activeBooking);
        this._activeBooking = this.storageService.get("INDRABFMDataStorageService._activeBooking");
    };
    INDRABFMDataStorageService.prototype.INDRA_setTierInformation = function (tierInformation) {
        this._activeBooking = this.INDRA_getActiveBookedTrip();
        var newTierInformation = __assign({}, this._activeBooking['tier-information']);
        Object.keys(tierInformation).forEach(function (tier) {
            if (!newTierInformation[tier])
                newTierInformation[tier] = tierInformation[tier];
        });
        var activeBooking = __assign({}, this._activeBooking, { 'tier-information': newTierInformation });
        this.storageService.set("INDRABFMDataStorageService._activeBooking", activeBooking);
        this._activeBooking = this.storageService.get("INDRABFMDataStorageService._activeBooking");
    };
    INDRABFMDataStorageService.prototype.INDRA_setPassengerTierBenefitInfo = function (newPassengerTierBenefitInfo) {
        this._activeBooking = this.INDRA_getActiveBookedTrip();
        var tierBenefitInfo = this._activeBooking.data.passengerTierBenefitInfo ? _.cloneDeep(this._activeBooking.data.passengerTierBenefitInfo) : [];
        newPassengerTierBenefitInfo.forEach(function (pax) {
            var i = tierBenefitInfo.findIndex(function (oldPax) { return oldPax.paxId === pax.paxId; });
            i === -1 ? tierBenefitInfo.push(pax) : tierBenefitInfo[i] = pax;
        });
        var activeBooking = __assign({}, this._activeBooking, { data: __assign({}, this._activeBooking.data, { passengerTierBenefitInfo: tierBenefitInfo }) });
        this.storageService.set("INDRABFMDataStorageService._activeBooking", activeBooking);
        this._activeBooking = this.storageService.get("INDRABFMDataStorageService._activeBooking");
    };
    INDRABFMDataStorageService.prototype.INDRA_getCountryCodes = function () {
        if (this._countryCode == undefined) {
            this._countryCode = this.storageService.get("INDRABFMDataStorageService._countryCode");
        }
        return this._countryCode;
    };
    INDRABFMDataStorageService.prototype.INDRA_setCountryCodes = function (countryCode) {
        this._countryCode = countryCode;
        this.storageService.set("INDRABFMDataStorageService._countryCode", this._countryCode);
    };
    Object.defineProperty(INDRABFMDataStorageService.prototype, "activeBooking", {
        get: function () {
            return this.INDRA_getActiveBookedTrip();
        },
        set: function (booking) {
            this._activeBooking = booking;
            this.storageService.set("INDRABFMDataStorageService._activeBooking", this._activeBooking);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABFMDataStorageService.prototype, "observableCurrentBooking", {
        get: function () {
            return this._observableCurrentBooking;
        },
        enumerable: true,
        configurable: true
    });
    INDRABFMDataStorageService.prototype.INDRA_setAtcAvailability = function (param) {
        this._atcAvailability = param;
        this.storageService.set("INDRABFMDataStorageService._atcAvailability", this._atcAvailability);
    };
    INDRABFMDataStorageService.prototype.INDRA_getAtcAvailability = function () {
        if (this._atcAvailability === undefined) {
            this._atcAvailability = this.storageService.get("INDRABFMDataStorageService._atcAvailability");
        }
        return this._atcAvailability;
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedForCancel = function () {
        if (this._selectedCancel === undefined) {
            this._selectedCancel = this.storageService.get("INDRABFMDataStorageService._selectedCancel");
        }
        return this._selectedCancel ? this._selectedCancel : [];
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedForCancel = function (selectedPassengers) {
        this._selectedCancel = selectedPassengers;
        this.storageService.set("INDRABFMDataStorageService._selectedCancel", this._selectedCancel);
    };
    INDRABFMDataStorageService.prototype.INDRA_setLastName = function (lastName) {
        this._lastName = lastName;
    };
    INDRABFMDataStorageService.prototype.INDRA_getLastName = function () {
        if (this._lastName == undefined) {
            this._lastName = this.storageService.get("lastname");
        }
        return this._lastName ? this._lastName : '';
    };
    INDRABFMDataStorageService.prototype.INDRA_getAtcRequest = function () {
        if (this._atcRequest == undefined) {
            this._atcRequest = this.storageService.get("INDRABFMDataStorageService._atcRequest");
        }
        return this._atcRequest;
    };
    INDRABFMDataStorageService.prototype.INDRA_setAtcRequest = function (atcRequest) {
        this._atcRequest = atcRequest;
        this.storageService.set("INDRABFMDataStorageService._atcRequest", this._atcRequest);
    };
    INDRABFMDataStorageService.prototype.INDRA_getCancelledDetails = function () {
        if (this._cancelledDetails == undefined) {
            this._cancelledDetails = this.storageService.get("INDRABFMDataStorageService._cancelledDetails");
        }
        return this._cancelledDetails;
    };
    INDRABFMDataStorageService.prototype.INDRA_setCancelledDetails = function (pnrDetails) {
        this._cancelledDetails = pnrDetails;
        this.storageService.set("INDRABFMDataStorageService._cancelledDetails", this._cancelledDetails);
    };
    INDRABFMDataStorageService.prototype.INDRA_getBoundSelectedFlight = function () {
        if (this._selectedFlightBound == undefined) {
            this._selectedFlightBound = this.storageService.get("INDRABFMDataStorageService._selectedFlightBound");
        }
        return this._selectedFlightBound ? this._selectedFlightBound : '';
    };
    INDRABFMDataStorageService.prototype.INDRA_setBoundSelectedFlight = function (bound) {
        this._selectedFlightBound = bound;
        this.storageService.set("INDRABFMDataStorageService._selectedFlightBound", this._selectedFlightBound);
    };
    INDRABFMDataStorageService.prototype.INDRA_setTotalSummaryDetails = function (details) {
        this.totalSummeryDetails = details;
        this.storageService.set("INDRABFMDataStorageService.totalSummeryDetails", this.totalSummeryDetails);
    };
    INDRABFMDataStorageService.prototype.INDRA_getTotalSummaryDetails = function () {
        if (this.totalSummeryDetails == undefined) {
            this.totalSummeryDetails = this.storageService.get("INDRABFMDataStorageService.totalSummeryDetails");
        }
        return this.totalSummeryDetails;
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedFlightChange = function (flight) {
        this._selectedFlightChange = flight;
        this.storageService.set("INDRABFMDataStorageService._selectedFlightChange", this._selectedFlightChange);
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedFlightChange = function () {
        if (this._selectedFlightChange == undefined) {
            this._selectedFlightChange = this.storageService.get("INDRABFMDataStorageService._selectedFlightChange");
        }
        return this._selectedFlightChange ? this._selectedFlightChange : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_setFlightToBeChange = function (flight) {
        this._flightToBeChange = flight;
        this.storageService.set("INDRABFMDataStorageService._flightToBeChange", this._flightToBeChange);
    };
    INDRABFMDataStorageService.prototype.INDRA_getFlightToBeChange = function () {
        if (this._flightToBeChange == undefined) {
            this._flightToBeChange = this.storageService.get("INDRABFMDataStorageService._flightToBeChange");
        }
        return this._flightToBeChange ? this._flightToBeChange : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_resetFlightChange = function () {
        this.INDRA_setFlightToBeChange(null);
        this.INDRA_setSelectedFlightChange(null);
    };
    INDRABFMDataStorageService.prototype.INDRA_getFlightToUpgradeCash = function () {
        if (this._selectedFlightUpgradeCash == undefined) {
            this._selectedFlightUpgradeCash = this.storageService.get("INDRABFMDataStorageService._selectedFlightUpgradeCash");
        }
        return this._selectedFlightUpgradeCash ? this._selectedFlightUpgradeCash : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_setFlightToUpgradeCash = function (selectedFlight) {
        this._selectedFlightUpgradeCash = selectedFlight;
        this.storageService.set("INDRABFMDataStorageService._selectedFlightUpgradeCash", this._selectedFlightUpgradeCash);
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedBrandToUpgradeCash = function () {
        if (this._selectedBrandUpgradeCash == undefined) {
            this._selectedBrandUpgradeCash = this.storageService.get("INDRABFMDataStorageService._selectedBrandUpgradeCash");
        }
        return this._selectedBrandUpgradeCash ? this._selectedBrandUpgradeCash : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedBrandToUpgradeCash = function (brand) {
        this._selectedBrandUpgradeCash = brand;
        this.storageService.set("INDRABFMDataStorageService._selectedBrandUpgradeCash", this._selectedBrandUpgradeCash);
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedBrandToChange = function () {
        if (this._selectedBrandToChange == undefined) {
            this._selectedBrandToChange = this.storageService.get("INDRABFMDataStorageService._selectedBrandToChange");
        }
        return this._selectedBrandToChange ? this._selectedBrandToChange : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedBrandToChange = function (brand) {
        this._selectedBrandToChange = brand;
        this.storageService.set("INDRABFMDataStorageService._selectedBrandToChange", this._selectedBrandToChange);
    };
    INDRABFMDataStorageService.prototype.INDRA_getDeletedPreviouslyPurchasedSeats = function () {
        if (this._deletedPreviouslyBoughtSeats == undefined) {
            this._deletedPreviouslyBoughtSeats = this.storageService.get("INDRABFMDataStorageService._deletedPreviouslyBoughtSeats");
        }
        return this._deletedPreviouslyBoughtSeats ? this._deletedPreviouslyBoughtSeats : [];
    };
    INDRABFMDataStorageService.prototype.INDRA_setDeletedPreviouslyPurchasedSeats = function (seats) {
        this._deletedPreviouslyBoughtSeats = seats;
        this.storageService.set("INDRABFMDataStorageService._deletedPreviouslyBoughtSeats", this._deletedPreviouslyBoughtSeats);
    };
    INDRABFMDataStorageService.prototype.INDRA_setFlightTickets = function (flight_tickets) {
        this._flight_tickets = flight_tickets;
        this.storageService.set("INDRABFMDataStorageService._flight_tickets", this._flight_tickets);
    };
    INDRABFMDataStorageService.prototype.INDRA_getFlightTickets = function () {
        if (this._flight_tickets == undefined) {
            this._flight_tickets = this.storageService.get("INDRABFMDataStorageService._flight_tickets");
        }
        return this._flight_tickets ? this._flight_tickets : [];
    };
    INDRABFMDataStorageService.prototype.INDRA_setPassengersToBeChange = function (pax) {
        this._paxToBeChange = pax;
        this.storageService.set("INDRABFMDataStorageService._paxToBeChange", this._paxToBeChange);
    };
    INDRABFMDataStorageService.prototype.INDRA_getPassengersToBeChange = function () {
        if (this._paxToBeChange == undefined) {
            this._paxToBeChange = this.storageService.get("INDRABFMDataStorageService._paxToBeChange");
        }
        return this._paxToBeChange ? this._paxToBeChange : null;
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedBrand = function (brand) {
        this.selectedBrandSubject.next(brand);
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedBrand = function () {
        return this.selectedBrandSubject.asObservable();
    };
    INDRABFMDataStorageService.prototype.INDRA_getBagCounts = function () {
        if (this._bagCounts == undefined) {
            this._bagCounts = this.storageService.get("INDRABFMDataStorageService._bagCounts");
        }
        return this._bagCounts ? this._bagCounts : [];
    };
    INDRABFMDataStorageService.prototype.INDRA_pushBagCountItem = function (bagCounts) {
        this._bagCounts.push(bagCounts);
        this.storageService.set("INDRABFMDataStorageService._bagCounts", this._bagCounts);
    };
    INDRABFMDataStorageService.prototype.INDRA_setOriginalPNRDetailsResponse = function (response) {
        this._originalPNRDetailsResponse = response;
        this.storageService.set("INDRABFMDataStorageService._originalPNRDetailsResponse", this._originalPNRDetailsResponse);
    };
    Object.defineProperty(INDRABFMDataStorageService.prototype, "originalPNRDetailsResponse", {
        get: function () {
            if (this._originalPNRDetailsResponse == undefined) {
                this._originalPNRDetailsResponse = this.storageService.get("INDRABFMDataStorageService._originalPNRDetailsResponse");
            }
            return this._originalPNRDetailsResponse;
        },
        enumerable: true,
        configurable: true
    });
    INDRABFMDataStorageService.prototype.INDRA_setSelectedBrandIndexToChange = function (brand, index) {
        if (!this._selectedBrandToChange || this._selectedBrandToChange.length <= 0) {
            this._selectedBrandToChange = [];
        }
        this._selectedBrandToChange[index] = brand[index];
        this.storageService.set("INDRABFMDataStorageService._selectedBrandToChange", this._selectedBrandToChange);
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedFlightIndexChange = function (flight, index) {
        if (!this._selectedFlightChange || this._selectedFlightChange.length <= 0) {
            this._selectedFlightChange = [];
        }
        this._selectedFlightChange[index] = flight[index];
        this.storageService.set("INDRABFMDataStorageService._selectedFlightChange", this._selectedFlightChange);
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectFlightBookingSteps = function (steps) {
        this._selectFlightBookingSteps = steps;
        this.storageService.set("INDRABFMDataStorageService._selectFlightBookingSteps", this._selectFlightBookingSteps);
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectFlightBookingSteps = function () {
        var _this = this;
        if (this._selectFlightBookingSteps == undefined) {
            var steps = [];
            this._selectFlightBookingSteps = [];
            steps = this.storageService.get("INDRABFMDataStorageService._selectFlightBookingSteps");
            steps.forEach(function (step) {
                _this._selectFlightBookingSteps.push(new INDRABookingStep(step._departure, step._destination, step._date, step._bound));
            });
        }
        return this._selectFlightBookingSteps;
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectFlightCurrentStep = function (step) {
        this._selectFlightCurrentStep = step;
        this.storageService.set("INDRABFMDataStorageService._selectFlightCurrentStep", this._selectFlightCurrentStep);
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectFlightCurrentStep = function () {
        if (this._selectFlightCurrentStep == undefined) {
            this._selectFlightCurrentStep = this.storageService.get("INDRABFMDataStorageService._selectFlightCurrentStep");
        }
        return this._selectFlightCurrentStep ? this._selectFlightCurrentStep : 0;
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedPassengersForUpgrade = function () {
        if (this._selectedPassengersForUpgrade == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._selectedPassengerForUpgrade');
            if (sessionValue != 'undefined') {
                this._selectedPassengersForUpgrade = sessionValue;
            }
        }
        return this._selectedPassengersForUpgrade ? this._selectedPassengersForUpgrade : [];
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedPassengersForUpgrade = function (selectedIndex) {
        this._selectedPassengersForUpgrade = selectedIndex;
        if (selectedIndex) {
            this.storageService.set('INDRABFMDataStorageService._selectedPassengerForUpgrade', this._selectedPassengersForUpgrade);
        }
        else {
            this.storageService.remove('INDRABFMDataStorageService._selectedPassengerForUpgrade');
        }
    };
    INDRABFMDataStorageService.prototype.INDRA_getUpgradeBrands = function () {
        if (this._upgradeBrands == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._upgradeBrands');
            if (sessionValue != 'undefined') {
                this._upgradeBrands = sessionValue;
            }
        }
        return this._upgradeBrands ? this._upgradeBrands : undefined;
    };
    INDRABFMDataStorageService.prototype.INDRA_setUpgradeBrands = function (brands) {
        this._upgradeBrands = brands;
        if (brands) {
            this.storageService.set('INDRABFMDataStorageService._upgradeBrands', this._upgradeBrands);
        }
        else {
            this.storageService.remove('INDRABFMDataStorageService._upgradeBrands');
        }
    };
    INDRABFMDataStorageService.prototype.INDRA_getSelectedBrandUpgrade = function () {
        if (this._selectedUpgradeBrand == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._selectedUpgradeBrand');
            if (sessionValue != 'undefined') {
                this._selectedUpgradeBrand = sessionValue;
            }
        }
        return this._selectedUpgradeBrand ? this._selectedUpgradeBrand : undefined;
    };
    INDRABFMDataStorageService.prototype.INDRA_setSelectedUpgradeBrand = function (selectedBrand) {
        this._selectedUpgradeBrand = selectedBrand;
        if (selectedBrand) {
            this.storageService.set('INDRABFMDataStorageService._selectedUpgradeBrand', this._selectedUpgradeBrand);
        }
        else {
            this.storageService.remove('INDRABFMDataStorageService._selectedUpgradeBrand');
        }
    };
    INDRABFMDataStorageService.prototype.INDRA_getBrandList = function () {
        if (this._brandList == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._brandList');
            if (sessionValue != 'undefined') {
                this._brandList = sessionValue;
            }
        }
        return this._brandList ? this._brandList : undefined;
    };
    INDRABFMDataStorageService.prototype.INDRA_setBrandList = function (brandList) {
        this._brandList = brandList;
        if (brandList) {
            this.storageService.set('INDRABFMDataStorageService._brandList', this._brandList);
        }
        else {
            this.storageService.remove('INDRABFMDataStorageService._brandList');
        }
    };
    INDRABFMDataStorageService.prototype.INDRA_setPaymentMethod = function (paymentMethod) {
        this._paymentMethod = paymentMethod;
    };
    INDRABFMDataStorageService.prototype.INDRA_getPaymentMethod = function () {
        return this._paymentMethod;
    };
    /******************* PHASE 2 CODE ADDITION *******************/
    INDRABFMDataStorageService.prototype.INDRA_setBookingAvailability = function (param) {
        this._bookingAvailability = param;
        // this.storageService.set('INDRABFMDataStorageService._bookingAvailability', this._bookingAvailability);
    };
    INDRABFMDataStorageService.prototype.INDRA_getBookingAvailability = function () {
        /*
        if (this._bookingAvailability === undefined) {
            this._bookingAvailability = this.storageService.get('INDRABFMDataStorageService._bookingAvailability');
        }
        */
        return this._bookingAvailability;
    };
    INDRABFMDataStorageService.prototype.INDRA_setStopoverInboundDate = function (date) {
        this.storageService.set('INDRAStopoverInboundDate', date);
    };
    INDRABFMDataStorageService.prototype.INDRA_getStopoverInboundDate = function () {
        return this.storageService.get('INDRAStopoverInboundDate');
    };
    INDRABFMDataStorageService.prototype.INDRA_removeStopoverInboundDate = function () {
        this.storageService.remove('INDRAStopoverInboundDate');
    };
    INDRABFMDataStorageService.prototype.INDRA_setStopoverOutboundDate = function (date) {
        this.storageService.set('INDRAStopoverOutboundDate', date);
    };
    INDRABFMDataStorageService.prototype.INDRA_getStopoverOutboundDate = function () {
        return this.storageService.get('INDRAStopoverOutboundDate');
    };
    INDRABFMDataStorageService.prototype.INDRA_removeStopoverOutboundDate = function () {
        this.storageService.remove('INDRAStopoverOutboundDate');
    };
    INDRABFMDataStorageService.prototype.INDRA_setOneWayStopoverOutboundDate = function (date) {
        this.storageService.set('INDRAOneWayStopoverOutboundDate', date);
    };
    INDRABFMDataStorageService.prototype.INDRA_getOneWayStopoverOutboundDate = function () {
        return this.storageService.get('INDRAOneWayStopoverOutboundDate');
    };
    INDRABFMDataStorageService.prototype.INDRA_removeOneWayStopoverOutboundDate = function () {
        this.storageService.remove('INDRAOneWayStopoverOutboundDate');
    };
    INDRABFMDataStorageService.prototype.INDRA_setStopoverDestination = function (location) {
        this.storageService.set('INDRAStopoverDestination', location);
    };
    INDRABFMDataStorageService.prototype.INDRA_getStopoverDestination = function () {
        return this.storageService.get('INDRAStopoverDestination');
    };
    INDRABFMDataStorageService.prototype.INDRA_removeStopoverDestination = function () {
        this.storageService.remove('INDRAStopoverDestination');
    };
    /**
     * Stores third party ancillaries (e.g. cars, hotels).
     * @param {string} booking - the booked trip to be stored
     */
    INDRABFMDataStorageService.prototype.INDRA_setThirdPartyAncillaries = function (bookingExtras) {
        this._thirdPartyAncillaries = bookingExtras;
        this.storageService.set("INDRABFMDataStorageService._thirdPartyAncillaries", this._thirdPartyAncillaries);
    };
    /**
     * Returns third party ancillaries (e.g. cars, hotels).
     */
    INDRABFMDataStorageService.prototype.INDRA_getThirdPartyAncillaries = function () {
        if (this._thirdPartyAncillaries == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._thirdPartyAncillaries');
            if (sessionValue != 'undefined') {
                this._thirdPartyAncillaries = sessionValue;
            }
        }
        return this._thirdPartyAncillaries ? this._thirdPartyAncillaries : undefined;
    };
    /**
     * Stores ancillaries packs.
     * @param {string} bookingPacks - ancillaries packs
     */
    INDRABFMDataStorageService.prototype.INDRA_setAncillariesPacks = function (bookingPacks) {
        this._ancillariesPacks = bookingPacks;
        this.storageService.set("INDRABFMDataStorageService._ancillariesPacks", this._ancillariesPacks);
    };
    /**
     * Returns ancillaries packs.
     */
    INDRABFMDataStorageService.prototype.INDRA_getAncillariesPacks = function () {
        if (this._ancillariesPacks == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._ancillariesPacks');
            if (sessionValue != 'undefined') {
                this._ancillariesPacks = sessionValue;
            }
        }
        return this._ancillariesPacks ? this._ancillariesPacks : undefined;
    };
    INDRABFMDataStorageService.prototype.INDRA_setTimeToThink = function (timeToThink) {
        this._timeToThink = timeToThink;
        if (timeToThink) {
            this.storageService.set('INDRABFMDataStorageService._timeToThink', this._timeToThink);
        }
        else {
            this.storageService.remove('INDRABFMDataStorageService._timeToThink');
        }
    };
    INDRABFMDataStorageService.prototype.INDRA_getTimeToThink = function () {
        if (this._timeToThink == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._timeToThink');
            if (sessionValue != 'undefined') {
                this._timeToThink = sessionValue;
            }
        }
        return this._timeToThink ? this._timeToThink : undefined;
    };
    /**
     * Stores available ancillaries per flight
     */
    INDRABFMDataStorageService.prototype.INDRA_setAncillariesPerFlight = function (ancillaryDetails) {
        this._ancillariesPerFlight = ancillaryDetails;
        this.storageService.set('INDRABFMDataStorageService._ancillariesPerFlight', this._ancillariesPerFlight);
    };
    /**
     * Returns available ancillaries per flight
     */
    INDRABFMDataStorageService.prototype.INDRA_getAncillariesPerFlight = function () {
        if (this._ancillariesPerFlight == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._ancillariesPerFlight');
            if (sessionValue != 'undefined') {
                this._ancillariesPerFlight = sessionValue;
            }
        }
        return this._ancillariesPerFlight ? this._ancillariesPerFlight : undefined;
    };
    /**
     * Retrieves a duplicate booked trip from the data store.
     */
    INDRABFMDataStorageService.prototype.INDRA_getDupeBookedTrip = function () {
        if (this._dupeBooking == undefined)
            this._dupeBooking = this.storageService.get('INDRABFMDataStorageService._dupeBooking');
        return this._dupeBooking;
    };
    /**
     * Stores the duplicate booked trip data.
     * @param {string} booking - the duplicate booked trip to be stored
     */
    INDRABFMDataStorageService.prototype.INDRA_setDupeBookedTrip = function (booking) {
        this._dupeBooking = booking;
        this.storageService.set('INDRABFMDataStorageService._dupeBooking', this._dupeBooking);
        this._observableCurrentBooking.next(this._dupeBooking);
    };
    /**
     * Retrieves user travel documentation confirmation from the data store.
     */
    INDRABFMDataStorageService.prototype.INDRA_getTravelDocumentationConfirm = function () {
        if (this._travelDocumentationConfirm == undefined)
            this._travelDocumentationConfirm = this.storageService.get('INDRABFMDataStorageService._travelDocumentationConfirm');
        return this._travelDocumentationConfirm;
    };
    /**
     * Stores user travel documentation confirmation data.
     * @param {string} booking - the duplicate booked trip to be stored
     */
    INDRABFMDataStorageService.prototype.INDRA_setTravelDocumentationConfirm = function (travelDocumentationConfirm) {
        this._travelDocumentationConfirm = travelDocumentationConfirm;
        this.storageService.set('INDRABFMDataStorageService._travelDocumentationConfirm', this._travelDocumentationConfirm);
    };
    /**
     * Retrieves user hazmat and baggage rules from the data store.
     */
    INDRABFMDataStorageService.prototype.INDRA_getTravelHazmatBaggageRulesConfirm = function () {
        if (this._travelHazmatBaggageRulesConfirm == undefined)
            this._travelHazmatBaggageRulesConfirm = this.storageService.get('INDRABFMDataStorageService._travelHazmatBaggageRulesConfirm');
        return this._travelHazmatBaggageRulesConfirm;
    };
    /**
     * Stores user hazmat and baggage rules confirmation data.
     * @param {string} booking - the duplicate booked trip to be stored
     */
    INDRABFMDataStorageService.prototype.INDRA_setTravelHazmatBaggageRulesConfirm = function (travelHazmatBaggageRulesConfirm) {
        this._travelHazmatBaggageRulesConfirm = travelHazmatBaggageRulesConfirm;
        this.storageService.set('INDRABFMDataStorageService._travelHazmatBaggageRulesConfirm', this._travelHazmatBaggageRulesConfirm);
    };
    /**
     * Stores matrix to compare if lowest price changes
     */
    INDRABFMDataStorageService.prototype.INDRA_setAvailabilityDatelist = function (param) {
        this._availabilityDatelist$.next(param);
    };
    INDRABFMDataStorageService.prototype.INDRA_getAvailabilityDatelist = function () {
        return this._availabilityDatelist$;
    };
    INDRABFMDataStorageService.prototype.INDRA_setTimeToThinkCode = function (code) {
        this._timeToThinkCode = code;
        this.timeToThinkCode.next(this._timeToThinkCode);
    };
    INDRABFMDataStorageService.prototype.INDRA_setTimeToThinkOptions = function (timeToThinkOptions) {
        this._timeToThinkOptions = timeToThinkOptions;
        if (timeToThinkOptions) {
            this.storageService.set('INDRABFMDataStorageService._timeToThinkOptions', this._timeToThinkOptions);
        }
        else {
            this.storageService.remove('INDRABFMDataStorageService._timeToThinkOptions');
        }
    };
    INDRABFMDataStorageService.prototype.INDRA_getTimeToThinkOptions = function () {
        if (this._timeToThinkOptions == undefined) {
            var sessionValue = this.storageService.get('INDRABFMDataStorageService._timeToThinkOptions');
            if (sessionValue != 'undefined') {
                this._timeToThinkOptions = sessionValue;
            }
        }
        return this._timeToThinkOptions ? this._timeToThinkOptions : undefined;
    };
    INDRABFMDataStorageService.prototype.INDRA_removeTimeToThinkOptions = function () {
        this.storageService.remove('INDRABFMDataStorageService._timeToThinkOptions');
    };
    INDRABFMDataStorageService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABFMDataStorageService_Factory() { return new INDRABFMDataStorageService(i0.inject(i1.INDRAStorageService)); }, token: INDRABFMDataStorageService, providedIn: "root" });
    return INDRABFMDataStorageService;
}());
export { INDRABFMDataStorageService };
